import { isoQS } from './isoQS';
import { read } from './read';

export default {
  read,
  isoQS,
};
